import { Types } from './actions';

interface IAction {
  type: string;
  payload: string;
}

interface IRecaptcha {
  siteKey: string | null;
  successKey: string | null;
}

interface IRecaptchaReturn {
  siteKey: string | null;
  successKey: string | null;
}

export const INITIAL_STATE: IRecaptcha = {
  siteKey: null,
  successKey: null,
};

export default function recaptcha(
  state = INITIAL_STATE,
  action: IAction,
): IRecaptchaReturn {
  switch (action.type) {
    case Types.SITE_KEY:
      return {
        ...state,
        siteKey: action.payload,
      };
    case Types.SUCCESS_KEY:
      return {
        ...state,
        successKey: action.payload,
      };
    default:
      return state;
  }
}
